// Branding van een verkoopteam over die van zijn energielabel leggen.
//
// SPIEGEL: backend/src/utils/brandingMerge.js bevat exact dezelfde regels. De
// backend gebruikt ze om `mine` te bepalen voor teamleader/verkoper (zodat het
// hele portaal na inloggen meteen de teamhuisstijl draagt); deze kopie dient
// voor admin/ET, die álle brandings binnenkrijgen en het Revenue-rapport moeten
// kunnen exporteren in de huisstijl van het GEKOZEN verkoopteam.
//
// Waarom per GROEP en niet per veld: logo, favicon, kleuren en achtergrond
// bestaan elk in een lichte en een donkere variant die elkaars terugval zijn
// (brandingForTheme). Zou een team enkel zijn lichte logo zetten, dan bleef bij
// veld-voor-veld overnemen het DONKERE logo van het energielabel staan — het
// donkere thema toonde dan het merk van een ander. Zet een team iets binnen een
// groep, dan neemt het die groep dus volledig over, inclusief de lege varianten.
export const BRANDING_GROUPS = [
  ['logo_data_url', 'logo_data_url_dark'],
  ['favicon_data_url', 'favicon_data_url_dark'],
  ['primary_color', 'primary_color_dark', 'secondary_color', 'secondary_color_dark', 'accent_color', 'accent_color_dark'],
  ['background_color', 'background_color_dark'],
  ['font_family'],
  ['display_name'],
];

// `basis` = branding van het energielabel, `over` = die van het verkoopteam.
// Het resultaat houdt energy_label van de basis (rapporten en de ET-compliance-
// check kijken daarnaar) en draagt sales_team als herkenningspunt.
export function mergeBranding(basis, over) {
  if (!over) return basis || null;
  if (!basis) return over;
  const uit = { ...basis };
  for (const groep of BRANDING_GROUPS) {
    if (!groep.some(v => over[v])) continue;
    for (const v of groep) uit[v] = over[v] || '';
  }
  if (over.sales_team) uit.sales_team = over.sales_team;
  return uit;
}
